<template>
    <a-modal :title="`支付注销费用(${props.tableColumnsData.full_name})`" :width="1000" :open="true" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button type="primary" :loading="state.submitLoading">确定</a-button>
            </a-popconfirm>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 6 }">
            <a-form ref="ruleForm" :model="formData" v-bind="formLayout">
                <a-form-item label="付款方式">
                    <a-radio-group v-model:value="formData.payment_method" button-style="solid">
                        <a-radio :value="8">微信付款</a-radio>
                        <a-radio :value="4">余额抵扣</a-radio>
                    </a-radio-group>
                </a-form-item>
                <div v-if="formData.payment_method == 8">
                    <a-form-item label="付款方">
                        <a-radio-group v-model:value="formData.wx_payer" button-style="solid">
                            <a-radio-button :value="1">代理商身份付款</a-radio-button>
                            <a-radio-button :value="2">续费联系人身份付款</a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="需要支付金额">
                        <template v-if="formData.wx_payer == 1" title="代理商付款">
                            <div style="font-size: 24px; color: red; line-height: 24px">
                                <div>￥{{ props.tableColumnsData.platform_price }}</div>
                            </div>
                        </template>
                        <template v-if="formData.wx_payer == 2" title="续费联系人付款">
                            <div>
                                <div v-if="state.cust_paid_editable">
                                    <a-input v-model:value="state.cust_paid_total" style="width: 80px"
                                        @pressEnter="saveCustPrice()" />
                                    <check-outlined class="editable-cell-icon-check" @click="saveCustPrice()" />
                                </div>
                                <div v-else>
                                    <span style="font-size: 24px; color: red; line-height: 24px" class="red">￥{{
                                        state.cust_paid_total }}</span>
                                    <edit-outlined class="editable-cell-icon" @click="editCustPrice()" />
                                </div>
                            </div>
                        </template>
                    </a-form-item>
                    <a-form-item label="操作">
                        <a-button type="primary" @click="onFormSubmit">点击弹出付款二维码</a-button>
                    </a-form-item>
                </div>
                <div v-else-if="formData.payment_method == 4">
                    <a-form-item label="余额">
                        ￥{{ state.moeny }}
                        <a @click="recharge" class="m-3x">点击充值</a>
                    </a-form-item>
                    <a-form-item label="需要支付金额">
                        <div style="font-size: 24px; color: red; line-height: 24px">
                            <div>￥{{ props.tableColumnsData.platform_price }}</div>
                        </div>
                    </a-form-item>
                    <a-form-item label="备注">
                        <a-textarea v-model:value="formData.remark" placeholder="请输入备注"
                            style="width: 400px"></a-textarea>
                    </a-form-item>
                </div>
            </a-form>
        </a-skeleton>
        <!-- 充值,这个后面处理 -->
        <!-- <PlatformBalanceCharge v-if="state.platformVisible" @cancel="handleOk" @ok="handleOk"
            :platformId="state.rechargeData.platform_id" :bussType="2">
        </PlatformBalanceCharge> -->
        <!-- 微信扫码支付 -->
        <WechatPayQrcode v-if="state.showQrcode" :qrcodeData="state.qrcodeData" @cancel="state.showQrcode = false" @ok="
            () => {
                emit('ok')
            }
        "></WechatPayQrcode>
    </a-modal>
</template>

<script lang="ts" setup>
import { reactive, onMounted, ref } from 'vue'
import { message } from 'ant-design-vue'
import { PlusOutlined, EditOutlined, CheckOutlined } from '@ant-design/icons-vue'
import PlatformBalanceCharge from './../../financialManagement/components/PlatformBalanceCharge.vue'
import WechatPayQrcode from '@/components/base/WechatPayQrcode.vue'
import baseService from '@/utils/http/axios'
const emit = defineEmits(['cancel', 'ok'])
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
    }
}
interface IformData {
    payment_method: number
    wx_payer: number
    remark: string
}
const formData = reactive<IformData>({
    payment_method: 8,
    wx_payer: 1, //微信支付付款人，1代理商，2续费联系人
    remark: ''
})
interface state {
    loading: boolean
    submitLoading: boolean
    moeny: number
    cust_paid_editable: boolean
    cust_paid_total: number // 总客户应付金额
    platformVisible: boolean
    rechargeData: Object
    showQrcode: boolean //微信支付二维码
    qrcodeData: Object
}
const state = reactive<state>({
    loading: false,
    submitLoading: false,
    moeny: 0,
    cust_paid_editable: false,
    cust_paid_total: 0, // 总客户应付金额
    platformVisible: false,
    rechargeData: {},
    showQrcode: false, //微信支付二维码
    qrcodeData: {}
})

onMounted(() => {
    queryMoney()
    getComputeOreder()
})
const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => { }
    }
})
//从后台获取价格
const getComputeOreder = () => {
    state.loading = true
    let requestParam = {
        url: '/admin/v1/calcel/getComputeOreder',
        method: 'post',
        data: { id: props.tableColumnsData.id }
    }
    baseService(requestParam)
        .then((res: any) => {
            state.cust_paid_total = res.data.sales_price
            props.tableColumnsData.platform_price = res.data.platform_price
        })
        .catch((res) => {
            message.error(res.msg)
        })
        .finally(() => {
            state.loading = false
        })
}
//编辑续费联系人付款
const editCustPrice = () => {
    state.cust_paid_editable = true
}
const saveCustPrice = () => {
    let requeryParam = {
        url: '/admin/v1/calcel/changeSalesPrice',
        method: 'post',
        data: {
            id: props.tableColumnsData.id, //客户id
            new_price: state.cust_paid_total
        }
    }
    baseService(requeryParam)
        .then((res: any) => {
            message.success(res.msg)
            state.cust_paid_editable = false
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('修改失败')
            }
        })
}
const queryMoney = () => {
    state.loading = true
    let requeryParam = {
        url: '/admin/user/getMoney',
        method: 'get'
    }
    baseService(requeryParam)
        .then((res) => {
            state.loading = false
            state.moeny = res.data.money
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取余额失败')
            }
        })
}

const onFormSubmit = () => {
    state.submitLoading = true
    let obj: any = {}
    if (formData.payment_method == 8) {
        //微信支付
        obj = {
            cancel_id: props.tableColumnsData.id, //客户id
            payment_method: 8, //微信支付
            remark: formData.remark, //付款备注
            wx_payer: formData.wx_payer //微信支付特有的
        }
    } else if (formData.payment_method == 4) {
        //余额支付
        obj = {
            cancel_id: props.tableColumnsData.id, //客户id
            payment_method: 4, //余额抵扣
            remark: formData.remark, //付款备注
            wx_payer: 1
        }
    }
    let requeryParam = {
        url: '/admin/v1/payCancelOreder',
        method: 'post',
        data: obj
    }
    baseService(requeryParam)
        .then((res: any) => {
            if (res.msg == 'showqrcode') {
                //显示微信扫的二维码
                state.qrcodeData = {
                    qrcode: res.data.code_url, //二维码url
                    qrcode_money: res.data.qrcode_money, //金额
                    payment_record_id: res.data.payment_record_id, //记录id
                    full_name: props.tableColumnsData.full_name, //名称
                    trade_type: res.data.trade_type
                }
                state.showQrcode = true
            } else {
                message.success(res.msg)
                emit('ok')
            }
            state.submitLoading = false
        })
        .catch((res) => {
            state.submitLoading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}

const cancel = () => {
    emit('cancel')
}
const recharge = () => {
    state.rechargeData = {
        upload_path: props.tableColumnsData.upload_path
    }
    state.platformVisible = true
}
const handleOk = () => {
    state.platformVisible = false
}
</script>

<style lang="less" scoped></style>
